// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"qVeax","rc-tabs-tab-active":"fEEFO","input-suffix":"zZ333","nav-item":"S9wA7","footerButton":"_1-cPw"};